import React from "react";

function PasswordSuccessLogo() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="65"
      height="65"
      viewBox="0 0 65 65"
      fill="none"
    >
      <circle cx="32.5" cy="32.0366" r="32" fill="#7950FF" />
      <path
        d="M49 23.0366L33.3241 38.2876C31.0176 40.5315 29.8644 41.6535 28.4428 41.6535C27.0211 41.6535 25.8679 40.5315 23.5615 38.2877L16.5 31.4176"
        stroke="white"
        strokeWidth="7"
      />
    </svg>
  );
}

export default PasswordSuccessLogo;
